import React from 'react';
import { Col, Row } from 'react-bootstrap';
const TopRowTitle = _ref => {
  let {
    title,
    showTopLine = false,
    children = null
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, showTopLine && /*#__PURE__*/React.createElement("hr", null), /*#__PURE__*/React.createElement(Row, {
    className: children ? '' : 'mb-3 mt-5'
  }, /*#__PURE__*/React.createElement(Col, {
    md: 7,
    className: "fw-bold"
  }, title), /*#__PURE__*/React.createElement(Col, {
    md: 5
  })), children && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, children));
};
export default TopRowTitle;